import { RequestConstants } from "../../../../core/request/RequestConstants";
import { WebRequest } from "../../../../core/request/WebRequest";
import { RealityCheckDetailsResponseData } from "../response/data/RealityCheckDetailsResponseData";
/**
 * RealityCheckDetailsRequest.ts
 */
export class RealityCheckDetailsRequest extends WebRequest {
    constructor() {
        super(RealityCheckDetailsRequest.URL);
    }
    getMethod() {
        return RequestConstants.GET;
    }
    getDataClass() {
        return RealityCheckDetailsResponseData;
    }
}
RealityCheckDetailsRequest.URL = "/gamecloud-servlets/api/user/realityCheckDetails";
//# sourceMappingURL=RealityCheckDetailsRequest.js.map